import { jsx as _jsx } from "react/jsx-runtime";
import React, { useState, useEffect, useImperativeHandle, forwardRef, } from 'react';
import PropTypes from 'prop-types';
import Alert from '../alert';
import Icon from '../icon';
import Button from '../button';
import classnames from 'classnames/bind';
import cls from './styles.scss';
const cx = classnames.bind(cls);
const SECONDS_TO_FADE = 0.3;
const BannerNotification = forwardRef(({ isOverlay }, ref) => {
    const [state, setState] = useState({
        isVisible: false,
        FadeInOut: false,
        message: '',
        title: '',
        role: '',
        dismissible: false,
        showIcon: false,
        iconName: '',
        slots: {},
    });
    let cleanupTimeout = null;
    let fadeTimeout = null;
    useEffect(() => {
        return () => {
            clearTimeout(cleanupTimeout);
            clearTimeout(fadeTimeout);
        };
    }, [cleanupTimeout, fadeTimeout]);
    const open = options => {
        setState(prevState => ({
            ...prevState,
            isVisible: true,
            ...options,
        }));
        setTimeout(() => {
            setState(prevState => ({
                ...prevState,
                FadeInOut: true,
            }));
        }, 0);
        if (options.autoDismiss) {
            cleanupTimeout && clearTimeout(cleanupTimeout);
            cleanupTimeout = setTimeout(close, options.duration);
        }
    };
    const resetState = () => {
        setState(prevState => ({ ...prevState, isVisible: false }));
    };
    const close = () => {
        setState(prevState => ({ ...prevState, FadeInOut: false }));
        fadeTimeout = setTimeout(() => {
            resetState();
            clearTimeout(fadeTimeout);
        }, SECONDS_TO_FADE * 1000);
    };
    const { isVisible, FadeInOut, message, title, role, dismissible, slots, showIcon, iconName, width, } = state;
    useImperativeHandle(ref, () => ({
        open,
        close,
    }));
    const renderIcon = iconName => iconName && (_jsx(Icon, { name: iconName, color: role, iconStyle: 'light', size: 'big' }));
    const dataElmId = `application_notification_${isOverlay ? 'overlay' : 'page'}_banner`;
    const pageLayoutWidth = document
        ?.querySelector('[data-page-width]')
        ?.getAttribute('data-page-width');
    const newWidth = width || pageLayoutWidth;
    return (_jsx("div", { className: cx({
            'overlay-banner-container': isOverlay,
            hidden: !isVisible,
            visible: isVisible,
        }, newWidth && `width-${newWidth}`), children: _jsx(Alert, { role: role, type: isOverlay ? 'overlayBanner' : 'pageBanner', header: title, content: message, onDismiss: isOverlay && dismissible ? close : null, slots: {
                secondaryAction: dismissible && !isOverlay
                    ? () => (_jsx(Button, { role: 'secondary', onClick: close, children: "Dismiss" }))
                    : undefined,
                ...slots,
            }, showIcon: iconName || showIcon, icon: renderIcon(iconName), className: cx({
                'overlay-banner': isOverlay,
                'inline-banner': !isOverlay,
                hidden: !isVisible,
                visible: isVisible,
                'fade-in': FadeInOut,
            }), "data-elm-id": dataElmId }) }));
});
BannerNotification.propTypes = {
    isOverlay: PropTypes.bool,
};
export default BannerNotification;
//# sourceMappingURL=index.js.map